import {
    bottomSheetChildrenAtom,
    bottomSheetTitleAtom,
    isBottomSheetOpenAtom,
} from '@states/uiAtoms';
import { useAtomValue } from 'jotai';

function useBottomSheetValues() {
    const title = useAtomValue(bottomSheetTitleAtom);
    const children = useAtomValue(bottomSheetChildrenAtom);
    const isOpen = useAtomValue(isBottomSheetOpenAtom);
    return {
        title, children, isOpen,
    };
}

export default useBottomSheetValues;
